module.exports = __webpack_public_path__ + "img/cmu.924be663.png";